module.exports = __webpack_public_path__ + "img/uid-token-bg-hen.fba0dfe1.png";